import { defineGameCard, onDeath } from '../authoring/index.js';
import { slimeDependencies, tableOf, trail } from './slime-helpers.js';
export const DividingSlimeCard = defineGameCard({
    id: 'dividing_slime',
    gameplay: { type: 'UNIT', cost: 5, baseStats: { attack: 4, health: 2 }, traits: ['SLIME'] },
    presentation: {
        name: 'Двоящийся слизень',
        description: 'След 1. После гибели создаёт до двух Малых слизней 3/1 в свободных ячейках этой локации.',
        glyph: {
            colors: ['#10213A', '#5DCCBC', '#66D5C5', '#358E8D', '#43A8A2'],
            rows: [
                '...............111..',
                '........1111..12221.',
                '......11333311121321',
                '.....143333332222231',
                '....1433333322333131',
                '.1114333333333233331',
                '1554531132221125411.',
                '151553332222222411..',
                '15555332332222241...',
                '15155332222222241...',
                '15545522222222341...',
                '.1145522222222341...',
                '...15522222223441...',
                '..1552522222454441..',
                '.155222222225544441.',
                '.123225555555552241.',
                '.122255555555445221.',
                '..1111111111111111..',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies('small_slime'),
    abilities: [
        trail(),
        onDeath((ctx, event) => {
            const controllerId = event.controllerIdAtDeath ?? ctx.self?.controllerId;
            if (controllerId === undefined)
                return;
            const tableId = tableOf(event.cellId);
            ctx.ops.createTokenInLocation('small_slime', controllerId, tableId);
            ctx.ops.createTokenInLocation('small_slime', controllerId, tableId);
        }),
    ],
    ui: { mechanics: ['token', 'death', 'trail', 'slime_residue'] },
});
//# sourceMappingURL=dividing_slime.js.map